/**
 * Định dạng số tiền DUY NHẤT cho giao diện mới (Lịch Bloc):
 * - dấu trừ là "−" (U+2212), không phải gạch nối;
 * - đầy đủ (1.234.567) cho dòng và số chính; gọn (1,2 tr) chỉ cho tổng hợp ở chỗ hẹp;
 * - số âm KHÔNG tô đỏ (xem MoneyText) — đỏ dành cho việc cần xử lý.
 */
export const MINUS = '−';

export const fmtMoney = (n: number, opts: { compact?: boolean; plus?: boolean } = {}): string => {
  const v = Number.isFinite(n) ? n : 0;
  const a = Math.abs(v);
  const sign = v < 0 ? MINUS : opts.plus && v > 0 ? '+' : '';
  if (opts.compact) {
    const f = (x: number, u: string) => `${sign}${(Math.round(x * 10) / 10).toLocaleString('vi-VN')} ${u}`;
    if (a >= 1e9) return f(a / 1e9, 'tỷ');
    if (a >= 1e6) return f(a / 1e6, 'tr');
    if (a >= 1e3) return `${sign}${Math.round(a / 1e3).toLocaleString('vi-VN')}k`;
    return `${sign}${Math.round(a).toLocaleString('vi-VN')}`;
  }
  return `${sign}${Math.round(a).toLocaleString('vi-VN')}`;
};
